import { useEffect, useMemo, useState } from 'react';

import type { CapsuleTableRow } from 'new/modules/settings/capsules/viewModels/capsulesTableViewModel';

export function useCapsulesTablePagination(rows: CapsuleTableRow[], pageSize: number) {
  const [page, setPage] = useState(1);

  const pageCount = Math.max(1, Math.ceil(rows.length / pageSize));
  const safePage = Math.min(page, pageCount);

  const paginatedRows = useMemo(
    () => rows.slice((safePage - 1) * pageSize, safePage * pageSize),
    [rows, safePage, pageSize],
  );

  useEffect(() => {
    if (page > pageCount) {
      setPage(pageCount);
    }
  }, [rows.length, pageCount, page]);

  const onPageChange = (_event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const showPagination = rows.length > pageSize;

  return {
    paginatedRows,
    page: safePage,
    pageCount,
    onPageChange,
    showPagination,
  };
}
